import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAtmType = (atmTypeId: number | undefined): Promise<IGetAtmType> => {
  return axiosDefaultApi.get(`/api/AtmTypes/GetAtmTypeViaID/${atmTypeId}`);
};

type QueryFnType = typeof getAtmType;

type UseGetAtmTypeOptions = {
  atmTypeId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAtmType = ({ atmTypeId , config }: UseGetAtmTypeOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getAtmType_${atmTypeId}`],
    queryFn: () => getAtmType(atmTypeId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Τύπου.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};